import { createGlobalStyle } from "styled-components";
import { normalize } from "styled-normalize";
import { getColorFromTheme } from "../utils/style-utils";
import { reset } from "./reset";
import { down } from "styled-breakpoints";
import halenoirRegular from "../assets/fonts/halenoir-font-family/Halenoir-Regular.otf";
import halenoirMedium from "../assets/fonts/halenoir-font-family/Halenoir-Medium.otf";
import halenoirSemiBold from "../assets/fonts/halenoir-font-family/Halenoir-SemiBold.otf";
import halenoirBold from "../assets/fonts/halenoir-font-family/Halenoir-Bold.otf";

export const GlobalStyle = createGlobalStyle`
    ${normalize}
    ${reset}
    @font-face { font-family: "Halenoir"; src: url(${halenoirRegular}) format("opentype"); font-style: normal; font-weight: 400; font-display: swap; }
    @font-face { font-family: "Halenoir"; src: url(${halenoirMedium}) format("opentype"); font-style: normal; font-weight: 500; font-display: swap; }
    @font-face { font-family: "Halenoir"; src: url(${halenoirSemiBold}) format("opentype"); font-style: normal; font-weight: 600; font-display: swap; }
    @font-face { font-family: "Halenoir"; src: url(${halenoirBold}) format("opentype"); font-style: normal; font-weight: 700; font-display: swap; }
    .font-halenoir{
        font-family: Halenoir, sans-serif !important;
    }
    .font-Kamerik{
        font-family: "Kamerik 205", sans-serif !important;
    }
    body {
        font-family: ${(props) => props.theme.fontFamily};
        margin: 0;
        padding: 0;
        -webkit-font-smoothing: antialiased;
        text-rendering: geometricPrecision;
        height: 100%;
        background: #ffffff;
        min-width: 300px;
    }

    /* @media (max-width: 575px) {
        body {
            max-width: 320px;
            margin-inline: auto;
        }
    } */

    h1, h2, h3, h4, h5, h6 {
        font-family: "Kamerik 205", sans-serif;
    }

    ${down("lg")} {
        body.mobile-scroll {
            overflow-y: visible !important;
        }
    }

    html, body {
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        overflow-x: hidden;
        scroll-behavior: smooth;
    }

    #root {
        min-height: 100vh;
        min-width: 300px;
        display: flex;
        flex-direction: column;
    }

    main {
        flex: 1;
    }

    * {
        box-sizing: border-box;
        border-width: 0;
        border-style: solid;
        border-top-style: solid;
        border-right-style: solid;
        border-bottom-style: solid;
        border-left-style: solid;
        border-color: #e5e7eb;
    }

    img, video {
        max-width: 100%;
        height: auto;
        vertical-align: middle;
    }

    input:not([type="image" i], [type="range" i], [type="checkbox" i], [type="radio" i]) {
        overflow-clip-margin: 0px !important;
        overflow: clip !important;
    }

    button, input, optgroup, select, textarea {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0px;
    }

    button, input, optgroup, select, textarea {
        font-family: inherit;
        font-feature-settings: inherit;
        font-variation-settings: inherit;
        font-size: 100%;
        font-weight: inherit;
        line-height: inherit;
        letter-spacing: inherit;
        color: inherit;
        margin: 0;
        padding: 0;
    }

    a:focus:not(.focus-visible),
    *:focus {
        outline: none;
        box-shadow: none;
    }

    a.focus-visible {
        outline: none;
        box-shadow: 0 0 0 3px ${getColorFromTheme("yellow100")};
    }

    .rnc__notification-container--top-right {
        position: absolute !important;;
    }

    .pac-container {
        z-index: 100000 !important;
    }

    .custom_app_discount {
        text-decoration: line-through;
        color: var(--color-secondary);
    }

    .custom-divider {
        margin: 16px 0;
        height: 1px;
        background-color: #F2F2F2;
        border-color: #F2F2F2;
    }

    .btn-outline-secondary:active,
    .btn-outline-secondary:focus,
    .btn-outline-secondary:focus-visible,
    .btn-outline-secondary:focus-within,
    .btn-outline-secondary:hover {
        background-color: transparent !important;
        color: inherit;
    }

    .otp-input {
        > div {
            gap: .5em;

            .otp-input-number {
                padding: 12px;
            }
        }

        ${down("md")} {
            > div {
                gap: .25em;

                .otp-input-number {
                    padding: 7px !important;
                }
            }
        }

        ${down("sm")} {
            > div {
                > span {
                    display: none;
                }

                .otp-input-number {
                    padding: 7px !important;
                }
            }
        }
    }

    .invalid-error {
        width: 100%;
        margin-top: .25rem;
        font-size: .875em;
        color: var(--bs-form-invalid-color);
    }

    label .required {
        color: var(--bs-form-invalid-color);
    }

    .custom-btn-outline-secondary {
        color: var(--color-primary);
        border-color: var(--color-primary);

        &:active, &:focus-within {
            border-color: var(--color-primary);
            color: var(--color-primary);
        }
    }

    .custom-btn-outline-danger {
        color: white !important;
        border-color: var(--color-danger) !important;
        background-color: var(--color-danger) !important;

        &:hover {
            border-color: var(--color-danger) !important;
            background-color: var(--color-danger) !important;
        }

        &:active, &:focus-within {
            border-color: var(--color-danger) !important;
        }
    }

    .custom-app-btn {
        --bs-btn-disabled-border-color: #0b9c07;
        border-color: #0b9c07;
        background-color: #0b9c07;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        border-radius: 36px;
        padding: 8.5px;
        font-weight: 600;
        font-size: 1em;
        --bs-btn-font-family: Halenoir;

        &:hover {
            background-color: #0b9c07 !important;
            border-color: #0b9c07 !important;
        }

        svg {
            margin-left: 4px;
        }
    }

    .inherit-all {
        all: inherit;
    }

    .btn.disabled, .btn:disabled, fieldset:disabled .btn {
        color: #ffffff8f;
        pointer-events: none;
        background-color: var(--bs-btn-disabled-bg);
        border-color: var(--bs-btn-disabled-border-color);
        --bs-btn-disabled-opacity: .43;
    }

    .avatar {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1000px;
        overflow: hidden;
        background-color: #AEDEAC;
        border: 1.5px solid var(--color-primary);
        margin-left: auto;
        margin-right: auto;

        span {
            color: var(--color-primary);
            font-weight: 600;
        }
    }

  .eyebrow-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    border-radius: 999px;
    padding: 8px 11px;
    background: rgba(231, 245, 230, 1);
    color: rgba(24, 27, 37, 1);
    font-size: 10px;
    font-weight: 500;
    text-transform: capitalize;

    svg {
      width: 16px;
      height: 16px;
    }
  }
  ${down("md")}{
    .eyebrow-pill {
        padding: 5.14px;
        gap: 2px;
        font-size: 8px;
        svg{
            width: 10.29px;
            height: 10.29px;
        }
    }
  }
  .page-title{
      margin: 16px 0 12px;
      color: #202720;
      font-family: "Kamerik 205", sans-serif;
      font-size: clamp(32px, 4vw, 32px);
      font-weight: 900;
      letter-spacing: -0.045em;
      line-height: 1.04;
  }
  .page-subtitle{
      max-width: 663px;
      margin: 0 auto;
      color: #657168;
      font-size: 18px;
      line-height: 1.5;

      @media (max-width: 767px) { font-size: 14px; }
  }
  @media (max-width: 575px) {
    .page-title {
        font-size: 24px;
    }
  }
  ${down("sm")}{
    .page-title{
        font-size: 24px;
    }
    .page-subtitle{
        max-width: 310px;
        font-size: 14px;
    }
  }
  .money{
    font-family: 'Saira';
  }
`;
